<div class="w-full mx-auto p-6 rounded-lg">
  <div class="titre3 mb-4">{{ 'USERS_MANAGEMENT.INVITE_ADMIN_PILOT' | translate }}</div>

  <div class="mb-4">
    <div class="flex flex-col space-y-2">
      @if (estPiloteGroupe) {
        <div class="flex items-center">
          <input type="checkbox" id="estInvitePilote" (change)="onRoleChange('pilote')"
            class="form-checkbox h-5 w-5 border-gray-300 rounded mr-2 focus:outline-none focus:ring-0"
            [(ngModel)]="estInvitePilote">
            <label for="estInvitePilote">{{ 'USERS_MANAGEMENT.PILOT' | translate }}</label>
          </div>
        }

        <div class="flex items-center">
          <input type="checkbox" id="estInviteAdmin" (change)="onRoleChange('admin')"
            class="form-checkbox h-5 w-5 text-gray-600 border-gray-300 rounded mr-2 focus:outline-none focus:ring-0"
            [(ngModel)]="estInviteAdmin">
            <label for="estInviteAdmin">{{ 'USERS_MANAGEMENT.ADMINISTRATOR' | translate }}</label>
          </div>

          @if (estInviteAdmin && entitesAccessibles.length === 1) {
            <span class="block mb-2">{{ 'USERS_MANAGEMENT.ADMIN_COMPANY' | translate }}: {{
            entitesAccessibles[0].nom }}</span>
          }

          @if (estInviteAdmin && entitesAccessibles.length > 1) {
            <div class="ml-6 mt-2">
              @if (entitesDispoInviteAdmin.length > 0) {
                <select title="entite"
                  [(ngModel)]="entiteIdInviteAdminSelectionnee" (change)="onEntiteInviteSelected($event)"
                  class="w-full p-2 border rounded">
                  <option [ngValue]="-1">{{ 'USERS_MANAGEMENT.SELECT_COMPANY' | translate }}</option>
                  @for (entite of entitesDispoInviteAdmin; track entite) {
                    <option [value]="entite.id" [disabled]="!entite.estActif">{{ entite.nom }}
                      @if (!entite.estActif) {
                        <span class="text-xs text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
                      }
                    </option>
                  }
                </select>
              }
              @if (inviteEntiteAdmins.length > 0) {
                <div class="mt-3">
                  <div class="titre4Modal">{{ 'USERS_MANAGEMENT.SELECTED_ENTITIES' | translate }}:</div>
                  <ul class="list-disc list-inside">
                    @for (entite of inviteEntiteAdmins; track entite) {
                      <li class="text-gray-600">
                        {{ entite.nom }}
                        <button (click)="removeSelectedEntity(entite.id)" class="ml-2 text-rougeNovo">{{
                        'USERS_MANAGEMENT.REMOVE' | translate }}</button>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <app-commun-invite [roleEntites]="entitesAccessibles" [limiterA5lignes]="true"
        [etiquettesDisponibles]="etiquettesAccessibles" (emailsChanged)="onEmailsChanged($event)"
        (entitySelected)="onEntitySelected($event)" (etiquettesSelectionnees)="onEtiquettesSelectionnees($event)">
      </app-commun-invite>


      <div class="flex justify-end mt-4">
        <button (click)="onCancel()" type="button"
          class="btn-secondary-novo">
          {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
        </button>
        <button
          [disabled]="isLoading || !entiteIdVisioSelectionne || courriels === null || courriels.length === 0 || (estInviteAdmin && inviteEntiteAdmins.length === 0) || (!estInvitePilote && !estInviteAdmin)"
          (click)="onSubmit()" type="submit"
          class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
          @if (!isLoading) {
            <span>{{ 'USERS_MANAGEMENT.INVITE' | translate }}</span>
          }
          @if (isLoading) {
            <mat-spinner [diameter]="24" [color]="'accent'"></mat-spinner>
          }
        </button>
      </div>
    </div>
